import React from "react";
import {
  errorForm,
  fireNewRelicErrorEvent,
} from "@origin-digital/reporting-client";
import { Card, StackSection } from "@origin-digital/ods-core";
import { ErrorMessage } from "@origin-digital/messages";

import { AppContextConsumer } from "../../context/AppContext";
import content from "./content.json";

interface IState {
  error?: Error;
}

interface IProps {}

export class ErrorWrapper extends React.PureComponent<IProps, IState> {
  public state: IState = {
    error: undefined,
  };

  private trackError = (error: Error) => {
    fireNewRelicErrorEvent(error);
    errorForm({
      errorCode: error.name,
      errorMessage: error.message,
    });
  };

  public componentDidCatch(error: Error) {
    this.setState({ error });
  }

  public render() {
    const { children } = this.props;
    const { error } = this.state;

    return (
      <AppContextConsumer>
        {({ context }) => {
          const thrownError = error || context.error;
          if (thrownError) {
            this.trackError(thrownError);
            return (
              <StackSection
                data-id="templated-microsite-error"
                hideGutter
                width="xlarge"
              >
                <Card>
                  <ErrorMessage
                    heading={content.error.heading}
                    text={content.error.text}
                  />
                </Card>
              </StackSection>
            );
          }

          return children;
        }}
      </AppContextConsumer>
    );
  }
}
